module.exports = __webpack_public_path__ + "static/media/pigeon.8dfa22b7.svg";